// src/guide/tickets/guide_creer_ticket.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_creer_ticket(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.tickets.nouveau_ticket.sujet.titre,
    translations.tickets.nouveau_ticket.sujet.texte,
    "#sujet_new_ticket",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.tickets.nouveau_ticket.rubrique.titre,
    translations.tickets.nouveau_ticket.rubrique.texte,
    "#rubrique_new_ticket"
  );
  guide_tour_step(
    tour,
    translations,
    translations.tickets.nouveau_ticket.type_ticket.titre,
    translations.tickets.nouveau_ticket.type_ticket.texte,
    "#radio"
  );

  guide_tour_step(
    tour,
    translations,
    translations.tickets.nouveau_ticket.pieces_jointes.titre,
    translations.tickets.nouveau_ticket.pieces_jointes.texte,
    "#file"
  );

  guide_tour_step(
    tour,
    translations,
    translations.tickets.nouveau_ticket.description.titre,
    translations.tickets.nouveau_ticket.description.texte,
    "#description_new_ticket"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.tickets.nouveau_ticket.valider_creation_ticket.titre,
    translations.tickets.nouveau_ticket.valider_creation_ticket.texte,
    "#click",
    "top"
  );

  tour.start();
}
